const baiduVisitorRouter = {
  path: '/baiduVisitor',
  component: () => import('@/components/common/temp/temp-index'),
  redirect: '/baiduVisitor/manage',
  name: 'baiduVisitorManage',
  meta: { title: '百度访客', roles: ['master'], requiresAuth: true, index: 'baiduVisitorManage' },
  children: [
    {
      path: 'manage',
      component: () => import('@/components/pages/baidu-visitor/manage'),
      meta: { title: '百度访客', roles: ['master'], requiresAuth: true, index: 'baiduVisitorManage' },
    },
    {
      path: 'detail/:_id',
      name: 'baiduVisitorDetail',
      component: () => import('@/components/pages/baidu-visitor/detail'),
      meta: { title: '百度访客', roles: ['master'], requiresAuth: true, index: 'baiduVisitorManage' },
    }
  ]
}
export default baiduVisitorRouter



// WEBPACK FOOTER //
// ./src/routers/modules/baidu-visitor.js